export const googlePlayRiderLink = 'https://play.google.com/store/apps/details?id=com.redtaxi.rider';
export const googlePlayDriverLink = 'https://play.google.com/store/apps/details?id=com.redtaxi.redtaxidriver';
export const appleRiderLink ='https://apps.apple.com/us/app/red-taxi-rider/id1611589045';
export const appleDriverLink = 'https://apps.apple.com/eg/app/red-taxi-driver/id1611604577';